import React, { useEffect, useState } from 'react';
import { Wrapper, Field, ErrorLabel } from './formFields.styles';

const Select = ({ error, id, label, name, type, value, placeholder, onChange, ...restSelectProps }) => {
  const [state, setState] = useState('');

  useEffect(() => {
    setState(value);
  }, [value]);

  useEffect(() => {
    if (label && !id) throw Error('id is required when label is passed!');
    if (!type) throw Error('Type for input field is required!');
  }, [label, id, type]);

  return (
    <Wrapper>
      {label && <label htmlFor={id}>{label}</label>}
      <Field type={type} id={id} name={name} value={state} onChange={onChange} error={error} placeholder={placeholder} {...restSelectProps} />
      {error && <ErrorLabel>{`⚠ ${error}`}</ErrorLabel>}
    </Wrapper>
  );
};

export default Select;
